/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MerchantUser } from './MerchantUser';
import {
    MerchantUserFromJSON,
    MerchantUserFromJSONTyped,
    MerchantUserToJSON,
    MerchantUserToJSONTyped,
} from './MerchantUser';

/**
 * 
 * @export
 * @interface GetBusinessBillingResponse
 */
export interface GetBusinessBillingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetBusinessBillingResponse
     */
    isAccountConnected: boolean;
    /**
     * See https://stripe.com/docs/api/accounts/retrieve
     * @type {object}
     * @memberof GetBusinessBillingResponse
     */
    stripeAccount?: object;
    /**
     * Stripe client secret for Stripe Connect embedded components. https://stripe.com/docs/connect/get-started-connect-embedded-components
     * @type {string}
     * @memberof GetBusinessBillingResponse
     */
    clientSecret?: string;
    /**
     * 
     * @type {MerchantUser}
     * @memberof GetBusinessBillingResponse
     */
    user?: MerchantUser;
}

/**
 * Check if a given object implements the GetBusinessBillingResponse interface.
 */
export function instanceOfGetBusinessBillingResponse(value: object): value is GetBusinessBillingResponse {
    if (!('isAccountConnected' in value) || value['isAccountConnected'] === undefined) return false;
    return true;
}

export function GetBusinessBillingResponseFromJSON(json: any): GetBusinessBillingResponse {
    return GetBusinessBillingResponseFromJSONTyped(json, false);
}

export function GetBusinessBillingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessBillingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isAccountConnected': json['isAccountConnected'],
        'stripeAccount': json['stripeAccount'] == null ? undefined : json['stripeAccount'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'user': json['user'] == null ? undefined : MerchantUserFromJSON(json['user']),
    };
}

export function GetBusinessBillingResponseToJSON(json: any): GetBusinessBillingResponse {
    return GetBusinessBillingResponseToJSONTyped(json, false);
}

export function GetBusinessBillingResponseToJSONTyped(value?: GetBusinessBillingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isAccountConnected': value['isAccountConnected'],
        'stripeAccount': value['stripeAccount'],
        'clientSecret': value['clientSecret'],
        'user': MerchantUserToJSON(value['user']),
    };
}

